// extracted by mini-css-extract-plugin
module.exports = {"ackOverview":"style_ackOverview__1wMmQ","title":"style_title__KjbdJ","blurb":"style_blurb__3YXOT","groupContainer":"style_groupContainer__ngF_a"};